module.exports = __webpack_public_path__ + "media/images/home-lulu2-80e2a5bbfacd52f5ecd350893e609492.jpg";